import styled from 'styled-components';

export const Container = styled.div`
  width: fit-content;
  margin: auto;
  padding: 16px;
`;

export const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  border-radius: 8px;
  label {
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }

    img {
      height: 214px;
      width: 214px;
      border: 3px solid rgba(255, 255, 255, 0.3);
      background: #eee;
      object-fit: cover;
    }

    input {
      display: none;
    }
  }
`;

export const DefaultAvatar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  object-fit: cover;
  width: 214px;
  height: 214px;
  border: 2px dashed #ddd;
  background: #fff;

  span {
    color: #ddd;
    font-size: 16px;
    font-weight: bold;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 44, 58, 0.9);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: #FF2C3A;
  }

  svg {
    fill: #fff;
    font-size: 22px;
  }
`;

export const InfoText = styled.p`
  color: #666;
  font-size: 12px;
  text-align: center;
  margin: 8px 0 0 0;
`;

export const CropContainer = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  background: #333;
  border-radius: 8px;
  overflow: hidden;
`;

export const CropControls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const ZoomControl = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  span {
    font-size: 14px;
    color: #666;
    min-width: 50px;
  }

  input[type='range'] {
    flex: 1;
    height: 4px;
    -webkit-appearance: none;
    background: #ddd;
    border-radius: 2px;
    outline: none;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      background: #0CCAB4;
      border-radius: 50%;
      cursor: pointer;
    }
  }
`;

export const CropActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
`;

export const ErrorText = styled.p`
  color: #FF2C3A;
  font-size: 12px;
  text-align: center;
  margin: 8px 0 0 0;
`;
